export default "__VITE_ASSET__B6JJGWsU__"